import React from "react";
import moment from "moment";
import { Query } from "react-apollo";
import RoomLive from "./roomLiveWrapper/RoomLive";
import { getVoucherByCode } from "../../graphql/query/voucher";
import { detectar_mobile } from "../../functions/mobileScreen";
import AntSpin from "../common/AntSpin";
import Exception500 from "../common/exception/500";
import img from "../../img/whats.png";

function validVoucher(voucher){
    let begin = moment(voucher[0].beginDate).format();
    let end = moment(voucher[0].endDate).format();

    if(moment().diff(begin, 'minutes') < 0){
        return false
    }else if(
        moment().diff(begin, 'minutes') > 0 &&
        moment().diff(end, 'minutes') < 0
    ){
        return true
    }else if(moment().diff(end, 'minutes') > 0){
        return false
    }       
}

export default function RoomLiveWrapper({history}){
    return(
        <Query 
            query={getVoucherByCode}
            variables={{ voucher: localStorage.getItem('@Ossel:voucher') }}
        >
            {({ loading, error, refetch, data }) => {
                if(error){
                    return <Exception500/>
                }else{
                    switch(loading ){
                        case true:
                            return <AntSpin marginTop="10%"/> 
                        case false:
                            let props = {
                                voucher: data.voucherByCode,
                                history,
                                refetch,
                                valid: validVoucher(data.voucherByCode),
                                validVoucher: validVoucher
                            };

                            return(
                                <div>
                                    <div id="promoImgWhats" >
                                        <a target="_blank" rel="noopener noreferrer" href="https://api.whatsapp.com/send?phone=5515998032893&text=Ol%C3%A1!%20Estou%20acompanhando%20a%20Cerim%C3%B4nia%20de%20Despedida%20e%20gostaria%20de%20prestar%20Homenagem%20atrav%C3%A9s%20de%20Coroa%20de%20Flores.">
                                            <img 
                                                alt="" 
                                                src={img} 
                                                style={
                                                    detectar_mobile() ? {height: "160px", marginRight: "22px", marginBottom: "20px"} : {height: "280px"}
                                                }
                                            />
                                        </a>
                                    </div>
                                    <RoomLive props={props}/>
                                </div>
                            )
                        default:
                            return null
                    }    
                }
            }}
        </Query>
    )
}


// WEBPACK FOOTER //
// ./src/components/general/RoomLiveWrapper.jsx